import {
  implementationTypologies,
  STORE_AGE_BRACKETS,
  type StoreAgeBracket,
} from '@gozoki/api-types'
import { z } from 'zod'
import {
  COMPARISON_CHOICES,
  COMPARISON_UNIVERSES,
} from '~/components/dashboards/filter-bar/comparison-model'
import { WEEK_PRESETS } from '~/components/dashboards/filter-bar/week-period-model'
import { realIsoDateSchema } from '~/lib/iso-date'

const LEGACY_OPENING_AGES: Record<string, StoreAgeBracket[]> = {
  comparables: ['more_than_12_months'],
  new: ['less_than_3_months', 'between_3_and_6_months', 'between_6_and_12_months'],
}

export const networkDashboardSearchSchema = z
  .object({
    storeIds: z.array(z.number()).default([]).catch([]),
    noStore: z.literal(true).optional().catch(undefined),
    ages: z
      .array(z.string())
      .default([])
      .catch([])
      .transform((codes) => STORE_AGE_BRACKETS.filter((bracket) => codes.includes(bracket))),
    opening: z.string().optional().catch(undefined),
    typologies: z
      .array(z.string())
      .default([])
      .catch([])
      .transform((codes) => implementationTypologies.filter((code) => codes.includes(code))),
    weekPreset: z.enum(WEEK_PRESETS).optional().catch(undefined),
    startDate: realIsoDateSchema.optional().catch(undefined),
    endDate: realIsoDateSchema.optional().catch(undefined),
    comparison: z.enum(COMPARISON_CHOICES).default('previous').catch('previous'),
    comparisonUniverse: z.enum(COMPARISON_UNIVERSES).default('same_stores').catch('same_stores'),
  })
  .transform(({ opening, ...search }) => ({
    ...search,
    ages:
      search.ages.length > 0 || opening === undefined
        ? search.ages
        : (LEGACY_OPENING_AGES[opening] ?? []),
  }))

export type NetworkDashboardSearch = z.infer<typeof networkDashboardSearchSchema>
